import moment from 'moment'
import { mapMutations, mapState, mapGetters } from 'vuex'

export const campusOfferMixin = {
  computed: {
    ...mapGetters('campusOffers', ['currentMonth']),
    ...mapState('campusOffers', ['clickMonthStr', 'fullMonthData', 'fullWeekData', 'monthThingsData'])
  },
  methods: {
    ...mapMutations('campusOffers', {
      setClickMonthStr: 'SET_CLICK_MONTH_STR',
      setDefaultDateStr: 'SET_DEFAULT_DATE_STR',
      setIsClick: 'SET_IS_CLICK',
      setFullMonthData: 'SET_FULL_MONTH_DATA',
      setFullWeekData: 'SET_FULL_WEEK_DATA',
      setCurrentSunday: 'SET_CURRENT_SUNDAY'
    }),
    // 处理当前页面translateX
    dealTranslateX(fullData, type, dateStr) {
      let otherFullData = type === 'calendarWeek' ? this.fullWeekData : this.fullMonthData
      let currentDateStr = dateStr || fullData[0].currentDateStr
      const otherIndex = otherFullData.findIndex(item => {
        let otherData = item.data.find(value => value.currentDateStr === currentDateStr)
        if (otherData) {
          return otherData.currentDateStr === currentDateStr
        }
      })
      // 处理月视图的时候滑动和点击的时候获取周视图的当前周第一天
      if (type === 'calendarWeek' && otherIndex > -1) {
        let { data } = otherFullData[otherIndex]
        if (data) {
          this.setCurrentSunday(data[0].currentDateStr)
        } 
      }
      this.translateIndex = -otherIndex + 1
    },
    // 点击日历
    changeCurrentMonth(item, type) {
      let data = this.calcCurrentMonth()
      this.setIsClick(true)
      this.setClickMonthStr(item.currentDateStr)
      if (type === 'calendarWeek') {
        this.$emit('calendarMonthClick', data, type, item.currentDateStr)
        this.$emit('changeCurrentMonth', item)
      }
      if (type === 'calendarMonth') {
        this.$emit('sameMonth', [item], type)
      }
      this.$emit('calendarClick', item.currentDateStr)
    }
  },
  filters: {
    todayTextFilter(val, data) {
      if (data.currentDateStr === moment().format('YYYY-MM-DD')) {
        return '今'
      } else {
        return val
      }
    }
  }
}